import { FC, useMemo } from 'react';
import { SelectProps } from 'antd';

import { Select as SelectAntd } from '@/features/vfo/uikit/Select';

import { useI18nValues } from '../hooks/useI18nValues';
import { Tags } from '../types';

const tagsList = Object.values(Tags);

export const SelectVfoTag: FC<SelectProps> = ({ placeholder, ...props }) => {
  const value = useI18nValues();

  const options = useMemo(() => {
    return tagsList.map((tag) => ({ value: tag, label: value.tag(tag) }));
  }, []);

  return <SelectAntd placeholder={placeholder} options={options} {...props} />;
};
